'use client';

import styled, { css } from 'styled-components';

import { device, hexToRGB, typography } from '@/styles/helpers';
import {
  AnimationHideKeyframes,
  AnimationTopHideKeyframes,
} from '@/styles/keyframes';

export const animateTopHide = (removeTimeout: number) => css`
  opacity: 0;
  transition: 1s ease;
  animation: ${AnimationTopHideKeyframes} ${removeTimeout}ms ease;
`;

export const animateHide = (removeTimeout: number) => css`
  opacity: 0;
  transition: 1s ease;
  animation: ${AnimationHideKeyframes} ${removeTimeout}ms ease;
`;

export interface ScTooltipProps {
  warning?: boolean;
  info?: boolean;
  success?: boolean;
  error?: boolean;
  animate?: boolean;
  inline?: boolean;
  removeTimeout: number;
}

export const ScTooltip = styled.div<ScTooltipProps>`
  position: relative;
  ${typography['body1regular']}
  white-space: pre-wrap;
  box-sizing: border-box;
  padding: 24px 40px 24px 24px;
  border-radius: 12px;
  color: ${({ theme }) => theme.blackColor};
  text-transform: none;
  background: ${({ theme }) => theme.whiteColor};
  display: flex;
  align-items: center;
  box-shadow: ${({ theme }) =>
    `0px 0px 10px 0px ${hexToRGB(theme.blackColor, 0.8)},
    0px 10px 10px 0px ${hexToRGB(theme.blackColor, 0.4)}`};

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
    flex-shrink: 0;

    svg,
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  & .title {
    letter-spacing: 0.16px;
    margin-bottom: 4px;
    font-weight: 700;
  }
`;

export const ScTooltipGlobal = styled(ScTooltip)`
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 11111;
  max-width: 400px;
  ${({ animate, removeTimeout }) =>
    animate ? animateHide(removeTimeout) : null};

  @media (${device.mobile}) {
    max-width: 100%;
    bottom: 76px;
    right: 8px;
    left: 8px;
  }
`;
